import { useTheme } from '@material-ui/core';
import AsyncMediaGallery from 'components/AsyncMediaGallery/AsyncMediaGallery';
import { FC, Fragment, useCallback, useState } from 'react';
import Masonry from 'react-responsive-masonry';
import { useMediaShareableProfileFormat } from 'shared/hooks/useMediaShareableProfileFormat';
import { InfoViewImageDataProps } from '../types';
import { InfoViewImageContainer, MasonryItem } from './InfoVIewImage.styles';
import InfoViewImageItem from './InfoViewImageItem/InfoViewImageItem';

type InfoViewImageProps = {
  infoViewImageData: InfoViewImageDataProps[];
};

const InfoViewImage: FC<InfoViewImageProps> = ({ infoViewImageData }) => {
  const { mappedData } = useMediaShareableProfileFormat(infoViewImageData);
  const [openGallery, setOpenGallery] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const theme = useTheme();
  const handleOpenGallery = useCallback((index: number) => {
    setOpenGallery((prev) => !prev);
    setSelectedIndex(index);
  }, []);
  return (
    <InfoViewImageContainer>
      {openGallery ? (
        <AsyncMediaGallery
          data={mappedData || []}
          selectedIndex={selectedIndex}
          type={'image'}
          openGallery={openGallery}
          handleOpenGallery={handleOpenGallery}
          sharedTheme={theme.palette.type}
          imageOption={{
            ratio: 'landscape',
          }}
        />
      ) : (
        <Fragment />
      )}
      <Masonry columnsCount={3} gutter="1rem">
        {infoViewImageData?.map((img, index: number) => {
          return (
            <MasonryItem key={img?.id || index} onClick={() => handleOpenGallery(index)}>
              <InfoViewImageItem
                image_url={img?.attributes?.modified_attachment_url || img?.attributes?.attachment_url || ''}
                index={index}
              />
            </MasonryItem>
          );
        })}
      </Masonry>
    </InfoViewImageContainer>
  );
};

export default InfoViewImage;
